import { useContext, useState, useEffect, useRef } from 'react';
import { WebApiContext } from 'ascendon-web-api';
import { translateFault, generateUnhandledFault } from '../../helpers/faults';

function useApplyCoupon() {
  const [fault, setFault] = useState(null);
  const [uiModel, setUiModel] = useState(null);
  const WebApi = useContext(WebApiContext);

  const isMounted = useRef(true);

  useEffect(
    () => () => {
      isMounted.current = false;
    },
    [],
  );

  const requestApplyCoupon = (newRequestData) => {
    WebApi.subscriber({
      callName: 'ApplyCoupon',
      keyFactors: ['ApplyCoupon'],
      forceRefresh: true,
      payload: newRequestData,
    })
      .then((response) => {
        if (isMounted.current) {
          setUiModel(response?.data);
        }
      })
      .catch((error) => {
        const code = error?.data?.Code;
        let errorMsg;
        if (!code) {
          const unknownFault = generateUnhandledFault(error.data);
          errorMsg = translateFault(unknownFault).translatedMessage;
          setFault(errorMsg);
        } else {
          errorMsg = translateFault(error.data).translatedMessage;
          setFault(errorMsg);
        }
      });
  };
  return [uiModel, fault, requestApplyCoupon];
}
export { useApplyCoupon };
export default useApplyCoupon;
